export default fn => new IntersectionObserver(fn);
